export enum EReceptDataTypeAggregation {
    PRESCRIBED = "PRESCRIBED",
    DISPENSED = "DISPENSED",
    DIFFERENCE = "DIFFERENCE"
}
